module.exports = __webpack_public_path__ + "img/codigobarras.ce57c034.png";